import React from "react"
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap"

export const ConfirmationModal = ({ isOpen, toggle, title, message, onConfirm, confirmText = "Confirmar", cancelText = "Cancelar", loading = false, warning = null }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={loading ? undefined : toggle}>
        {title}
      </ModalHeader>
      <ModalBody>
        <p>{message}</p>
        {warning && (
          <Alert color="warning" className="mt-3">
            {warning}
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          color="danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-1" />
              Processando...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
